
// import React, { useState } from 'react';
// import { useDispatch } from 'react-redux';
// import { addCoupon } from '../../redux/actions/couponActions'; // Import your action creator

// const AddCoupon = ({ onCloseModal }) => {
//   const [couponData, setCouponData] = useState({
//     name: '',
//     code: '',
//     description: '',
//     discountValue: '',
//     discountType: '',
//     minimumPurchase: '',
//     usageLimit: '',
//     startDate: '',
//     endDate: ''
//   });

//   const dispatch = useDispatch(); // Hook to dispatch the action

//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setCouponData({ ...couponData, [name]: value });
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     try {
//       // Call the addCoupon thunk action to make the API call
//       await dispatch(addCoupon(couponData));
//       onCloseModal(); // Close the modal after successful submission
//     } catch (error) {
//       console.error('Failed to add coupon:', error);
//     }
//   };

//   return (
//     <div className="fixed inset-0 flex justify-center items-center bg-gray-600 bg-opacity-50 z-50">
//       <div className="bg-white p-6 rounded-md shadow-lg w-full max-w-lg">
//         <h2 className="text-xl font-bold mb-4">Add New Coupon</h2>

//         <form onSubmit={handleSubmit}>
//           <div className="mb-4">
//             <label className="block text-sm font-medium">Coupon Name</label>
//             <input
//               type="text"
//               name="name"
//               value={couponData.name}
//               onChange={handleChange}
//               className="w-full p-2 border rounded-md"
//               required
//             />
//           </div>
//           <div className="mb-4">
//             <label className="block text-sm font-medium">Coupon Code</label>
//             <input
//               type="text"
//               name="code"
//               value={couponData.code}
//               onChange={handleChange}
//               className="w-full p-2 border rounded-md"
//               required
//             />
//           </div>
//           <div className="mb-4">
//             <label className="block text-sm font-medium">Description</label>
//             <textarea
//               name="description"
//               value={couponData.description}
//               onChange={handleChange}
//               className="w-full p-2 border rounded-md"
//               rows="3"
//             />
//           </div>
//           <div className="mb-4 flex space-x-4">
//             <div className="flex-1">
//               <label className="block text-sm font-medium">Discount Value</label>
//               <input
//                 type="number"
//                 name="discountValue"
//                 value={couponData.discountValue}
//                 onChange={handleChange}
//                 className="w-full p-2 border rounded-md"
//                 required
//               />
//             </div>
//             <div className="flex-1">
//               <label className="block text-sm font-medium">Discount Type</label>
//               <select
//                 name="discountType"
//                 value={couponData.discountType}
//                 onChange={handleChange}
//                 className="w-full p-2 border rounded-md"
//                 required
//               >
//                 <option value="">Select Type</option>
//                 <option value="percentage">Percentage</option>
//                 <option value="flat">Flat</option>
//               </select>
//             </div>
//           </div>
          
//           <div className="mb-4 flex space-x-4">
//             <div className="flex-1">
//               <label className="block text-sm font-medium">Minimum Purchase</label>
//               <input
//                 type="number"
//                 name="minimumPurchase"
//                 value={couponData.minimumPurchase}
//                 onChange={handleChange}
//                 className="w-full p-2 border rounded-md"
//               />
//             </div>
//             <div className="flex-1">
//               <label className="block text-sm font-medium">Usage Limit</label>
//               <input
//                 type="number"
//                 name="usageLimit"
//                 value={couponData.usageLimit}
//                 onChange={handleChange}
//                 className="w-full p-2 border rounded-md"
//               />
//             </div>
//           </div>

//           <div className="mb-4 flex space-x-4">
//             <div className="flex-1">
//               <label className="block text-sm font-medium">Start Date</label>
//               <input
//                 type="date"
//                 name="startDate"
//                 value={couponData.startDate}
//                 onChange={handleChange}
//                 className="w-full p-2 border rounded-md"
//                 required
//               />
//             </div>
//             <div className="flex-1">
//               <label className="block text-sm font-medium">End Date</label>
//               <input
//                 type="date"
//                 name="endDate"
//                 value={couponData.endDate}
//                 onChange={handleChange}
//                 className="w-full p-2 border rounded-md"
//                 required
//               />
//             </div>
//           </div>

//           <div className="flex justify-between items-center">
//             <button
//               type="button"
//               onClick={onCloseModal}
//               className="bg-gray-300 p-2 rounded-md"
//             >
//               Cancel
//             </button>
//             <button
//               type="submit"
//               className="bg-blue-600 text-white p-2 rounded-md"
//             >
//               Add Coupon
//             </button>
//           </div>
//         </form>
//       </div>
//     </div>
//   );
// };

// export default AddCoupon;


import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { addCoupon } from '../../redux/actions/couponActions';

const AddCoupon = ({ onCloseModal }) => {
  const [couponData, setCouponData] = useState({
    name: '',
    code: '',
    description: '',
    discountValue: '',
    discountType: '',
    minimumPurchase: '',
    usageLimit: '',
    startDate: '',
    endDate: ''
  });

  const dispatch = useDispatch();

  const handleChange = (e) => {
    const { name, value } = e.target;
    setCouponData({ ...couponData, [name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await dispatch(addCoupon(couponData));
      onCloseModal();
    } catch (error) {
      console.error('Failed to add coupon:', error);
    }
  };

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50 p-4">
      <div className="bg-white rounded-xl shadow-2xl w-full max-w-md overflow-hidden">
        <div className="p-6 border-b border-gray-200">
          <h2 className="text-2xl font-semibold text-gray-800">Create New Coupon</h2>
        </div>

        <form onSubmit={handleSubmit} className="p-6 space-y-6 max-h-[80vh] overflow-y-auto">
          <div className="space-y-4">
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">Coupon Name</label>
              <input
                type="text"
                name="name"
                value={couponData.name}
                onChange={handleChange}
                className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all"
                placeholder="Summer Sale"
                required
              />
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">Coupon Code</label>
              <input
                type="text"
                name="code"
                value={couponData.code}
                onChange={handleChange}
                className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all uppercase"
                placeholder="SUMMER25"
                required
              />
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">Description</label>
              <textarea
                name="description"
                value={couponData.description}
                onChange={handleChange}
                className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all"
                rows="3"
                placeholder="Enter coupon description..."
              />
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Discount Value</label>
                <input
                  type="number"
                  name="discountValue"
                  value={couponData.discountValue}
                  onChange={handleChange}
                  className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all"
                  placeholder="0"
                  required
                />
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Discount Type</label>
                <select
                  name="discountType"
                  value={couponData.discountType}
                  onChange={handleChange}
                  className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all bg-white"
                  required
                >
                  <option value="">Select Type</option>
                  <option value="percentage">Percentage (%)</option>
                  <option value="flat">Flat Amount</option>
                </select>
              </div>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Minimum Purchase</label>
                <input
                  type="number"
                  name="minimumPurchase"
                  value={couponData.minimumPurchase}
                  onChange={handleChange}
                  className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all"
                  placeholder="No minimum"
                />
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Usage Limit</label>
                <input
                  type="number"
                  name="usageLimit"
                  value={couponData.usageLimit}
                  onChange={handleChange}
                  className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all"
                  placeholder="Unlimited"
                />
              </div>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Start Date</label>
                <input
                  type="date"
                  name="startDate"
                  value={couponData.startDate}
                  onChange={handleChange}
                  className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all"
                  required
                />
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">End Date</label>
                <input
                  type="date"
                  name="endDate"
                  value={couponData.endDate}
                  onChange={handleChange}
                  className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all"
                  required
                />
              </div>
            </div>
          </div>

          <div className="flex flex-col sm:flex-row gap-3 justify-end pt-4">
            <button
              type="button"
              onClick={onCloseModal}
              className="w-full sm:w-auto px-6 py-2 border border-gray-300 rounded-lg font-medium text-gray-700 hover:bg-gray-50 transition-colors"
            >
              Cancel
            </button>
            <button
              type="submit"
              className="w-full sm:w-auto px-6 py-2 bg-blue-600 hover:bg-blue-700 rounded-lg font-medium text-white transition-colors"
            >
              Create Coupon
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default AddCoupon;